import React from 'react';
import Icon from '@anwb/icon';
import { DateInputCalendarTrigger } from '../styles';
export const Trigger = ({ colorContext, disabled = false, onClick }) => {
    return (React.createElement(DateInputCalendarTrigger, { "data-ignore-outside-click": "true", type: "button", disabled: disabled, "$colorContext": colorContext, onClick: onClick },
        React.createElement(Icon, { variant: "calendar", size: "lg" })));
};
//# sourceMappingURL=Trigger.js.map